$shm_textarea_code_rows $mol_list
